import * as SupplierService from '../../../../services/supplier.service';
import * as SupplierSuggestion from '../../../../services/supplierSuggestion.service';
import PlaceholderManagementType from './PlaceHolderManagement.type';
import { toasterMsg } from '../../../../Components/Toaster/Toaster';

export const addPlaceholderManagement = async (obj) => {
  try {
    const data = await SupplierService.addPlaceholderManagement(obj);
    if (data) {
      toasterMsg(data.message, 'success');
    }
  } catch (e) {
    toasterMsg(e.message, 'error');
  }
};

export const fetchCategoryAction = (params) => async (dispatch) => {
  try {
    const res = await SupplierService.getAllCategory(params);

    if (res.code === 200 && res.data) {
      switch (params.categoryType) {
        case 1:
          await dispatch({
            type: PlaceholderManagementType.CATEGORY1,
            payload: res.data,
          });
          return res.data;

        case 2:
          await dispatch({
            type: PlaceholderManagementType.CATEGORY2,
            payload: res.data,
          });
          return res.data;

        default:
          return res.data;
      }
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const fetchAllBrandAction = (params) => async (dispatch) => {
  try {
    const res = await SupplierService.getAllBrands(params);
    if (res.code === 200 && res.data) {
      await dispatch({
        type: PlaceholderManagementType.BRANDS,
        payload: res.data,
      });
      return res.data;
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const fetchAllSeasonsAction = (id) => async (dispatch) => {
  try {
    const res = await SupplierSuggestion.getSeasons(id);

    if (res.code === 200 && res.data) {
      await dispatch({
        type: PlaceholderManagementType.SEASONS,
        payload: res.data,
      });
      return res.data;
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};
